import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { useSetTitle } from '@/stores/title-context';

import { PipelineBoardPage } from '@/pages/crm/pipeline/PipelineBoardPage';
import { boardSearchSchema } from '@/pages/crm/pipeline/boardSearch';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// /crm/pipeline resolves to the tenant's default pipeline board (deals-board.md).
function PipelineBoardIndexRoute() {
	const { t } = useLingui();
	useSetTitle(t`Pipeline`);
	return <PipelineBoardPage />;
}

export const Route = createFileRoute('/_authenticated/_app/crm/pipeline/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['deals.read.own', 'deals.read.all'], redirectTo: '/dashboard' }),
	component: PipelineBoardIndexRoute,
	validateSearch: boardSearchSchema,
});
